import React, { Component } from "react";
import "./Monitor.scss";
import { connect } from "react-redux";
import 'react-widgets/dist/css/react-widgets.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import LoadingOverlay from 'react-loading-overlay';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs"
import { Row, Col, Card, ListGroup, ListGroupItem } from "react-bootstrap";
import {
	getMainApiStatus, getStadisticApiStatus, getSyncGeneralApiStatus,
	getSyncStockApiStatus, getJobLogs
} from "../../../../actions/ApiActions"
import {
	GET_API_MAIN_STATUS, GET_API_SYNC_STOCK_STATUS, GET_API_SYNC_GENERAL_STATUS,
	GET_API_STADISTICS_STATUS, GET_JOB_LOGS, GET_ERRORS
} from "../../../../actions/types";

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Monitor extends Component {

	state = {
		mainApiData: {
			date: "",
			status: "ERROR"
		},
		stadisticApiData: {
			date: "",
			status: "ERROR"
		},
		syncStockApiData: {
			date: "",
			status: "ERROR"
		},
		syncGeneralApiData: {
			date: "",
			status: "ERROR"
		},
		jobLogs: [],
		showSnackBar: false,
		textSnackBar: '',
		severitySnackBar: 'success',
		tabIndex: 0,
		activeLoader: true
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.getMainApiStatus();
		this.props.getStadisticApiStatus();
		this.props.getSyncStockApiStatus();
		this.props.getSyncGeneralApiStatus();
		setTimeout(() => {
			this.setState({
				activeLoader: false
			});
		}, 2000)
	}

	componentDidUpdate(prevProps) {
		if (this.props.actionType === GET_API_MAIN_STATUS && prevProps.actionType !== GET_API_MAIN_STATUS) {
			this.setState({
				mainApiData: {
					date: this.props.dataApiMain.date,
					status: "OK"
				}
			});
		}
		else if (this.props.actionType === GET_API_STADISTICS_STATUS && prevProps.actionType !== GET_API_STADISTICS_STATUS) {
			this.setState({
				stadisticApiData: {
					date: this.props.dataApiStadistics.ConsultationDate,
					status: "OK"
				}
			});
		}
		else if (this.props.actionType === GET_API_SYNC_STOCK_STATUS && prevProps.actionType !== GET_API_SYNC_STOCK_STATUS) {
			this.setState({
				syncStockApiData: {
					date: this.props.dataApiSyncStock.date,
					status: "OK"
				}
			});
		}
		else if (this.props.actionType === GET_API_SYNC_GENERAL_STATUS && prevProps.actionType !== GET_API_SYNC_GENERAL_STATUS) {
			this.setState({
				syncGeneralApiData: {
					date: this.props.dataApiSyncGeneral.date,
					status: "OK"
				}
			});
		}
		else if (this.props.actionType === GET_JOB_LOGS && prevProps.actionType !== GET_JOB_LOGS) {
			this.setState({
				activeLoader: false,
				jobLogs: this.props.jobLogs
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: 'error',
			});
		}
	}

	formatDate(date) {
		return new Date(date).toLocaleDateString();
	}

	formatTime(date) {
		return new Date(date).toLocaleTimeString();
	}

	changeTabIndex(tabIndex) {
		this.setState({ tabIndex });
		if (tabIndex === 0) {
			this.setState({
				activeLoader: true,
			});
			this.props.getMainApiStatus();
			this.props.getStadisticApiStatus();
			this.props.getSyncStockApiStatus();
			this.props.getSyncGeneralApiStatus();
			setTimeout(() => {
				this.setState({
					activeLoader: false
				});
			}, 2000)
		}
		else if (tabIndex === 1) {
			this.setState({
				activeLoader: true,
			});
			this.props.getJobLogs();
		}
	}

	render() {

		const columns = [
			{
				dataField: 'name',
				text: 'Nombre',
				headerStyle: () => {
					return { width: "30%" };
				},
			},
			{
				dataField: 'date',
				text: 'Fecha de ejecución',
				headerStyle: () => {
					return { width: "40%" };
				},
				formatter: (cell) => {
					return this.formatDate(cell) + " " + this.formatTime(cell);
				}
			},
			{
				dataField: 'message',
				text: 'Estatus',
				headerStyle: () => {
					return { width: "30%" };
				},
			},
		];

		return (
			<div className="main-content">
				<div className="malls-category-headers">
					Monitor de servicios
				</div>
				<div className="user-category-wrapper">
					<Tabs
						selectedIndex={this.state.tabIndex}
						onSelect={tabIndex => this.changeTabIndex(tabIndex)}
						default={true}
						style={{ width: "100%" }}
					>
						<TabList >
							<Tab>Microservicios</Tab>
							<Tab>Jobs</Tab>
						</TabList>

						<TabPanel >
							<Col xs={12} sm={12} md={12} lg={12}>
								<Row>
									<Col xs={12} sm={6} md={4} lg={4}>
										<Card.Header>API PRINCIPAL</Card.Header>
										<Card className="mb-2" border="primary">
											<Card.Body>
												<Card.Text>
													Procesos generales a esta api se conectan aplicaciones, ecommerce y CMS.
												</Card.Text>
											</Card.Body>
											<ListGroup className="list-group-flush">
												<ListGroupItem>Fecha : {this.formatDate(this.state.mainApiData.date)}</ListGroupItem>
												<ListGroupItem>Hora : {this.formatTime(this.state.mainApiData.date)}</ListGroupItem>
												<ListGroupItem>{this.state.mainApiData.status}</ListGroupItem>
											</ListGroup>
										</Card>
									</Col>
									<Col xs={12} sm={6} md={4} lg={4}>
										<Card.Header>API SYNC (EXISTENCIAS)</Card.Header>
										<Card className="mb-2" border="primary">
											<Card.Body>
												<Card.Text>
													Esta api contiene servicios que permite la sincronización de existencias (Normales y de lote).
												</Card.Text>
											</Card.Body>
											<ListGroup className="list-group-flush">
												<ListGroupItem>Fecha : {this.formatDate(this.state.syncStockApiData.date)}</ListGroupItem>
												<ListGroupItem>Hora : {this.formatTime(this.state.syncStockApiData.date)}</ListGroupItem>
												<ListGroupItem>{this.state.syncStockApiData.status}</ListGroupItem>
											</ListGroup>
										</Card>
									</Col>
									<Col xs={12} sm={6} md={4} lg={4}>
										<Card.Header>API SYNC (GENERAL)</Card.Header>
										<Card className="mb-2" border="primary">
											<Card.Body>
												<Card.Text>
													Esta api contiene servicios que permite la sincronización de todo tipo, con excepción de existencias.
												</Card.Text>
											</Card.Body>
											<ListGroup className="list-group-flush">
												<ListGroupItem>Fecha : {this.formatDate(this.state.syncGeneralApiData.date)}</ListGroupItem>
												<ListGroupItem>Hora : {this.formatTime(this.state.syncGeneralApiData.date)}</ListGroupItem>
												<ListGroupItem>{this.state.syncGeneralApiData.status}</ListGroupItem>
											</ListGroup>
										</Card>
									</Col>
								</Row>
								<Row>
									<Col xs={12} sm={6} md={4} lg={4}>
										<Card.Header>API STADISTICS</Card.Header>
										<Card className="mb-2" border="primary">
											<Card.Body>
												<Card.Text>
													Esta api sincroniza ventas para BI.
												</Card.Text>
											</Card.Body>
											<ListGroup className="list-group-flush">
												<ListGroupItem>Fecha : {this.formatDate(this.state.stadisticApiData.date)}</ListGroupItem>
												<ListGroupItem>Hora : {this.formatTime(this.state.stadisticApiData.date)}</ListGroupItem>
												<ListGroupItem>{this.state.stadisticApiData.status}</ListGroupItem>
											</ListGroup>
										</Card>
									</Col>
								</Row>
							</Col>
						</TabPanel>
						<TabPanel >
							<Col xs={12} sm={12} md={12} lg={12}>
								<Row>
									<div style={{ textAlign: "left", height: "60vh", overflow: "auto", width: "100%", marginTop: "2vh" }}>
										{
											<BootstrapTable keyField='name'
												key="8908290138209"
												striped
												hover
												condensed
												data={this.state.jobLogs}
												headerWrapperClasses="title-table"
												rowClasses="custom-row-table"
												columns={columns}
											/>
										}
									</div>
								</Row>
							</Col>
						</TabPanel>
					</Tabs>
				</div>
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
				}
				{
					<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
						<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>
		);

	}
}

const mapStateToProps = state => ({
	error: state.api_reducer.error,
	dataApiMain: state.api_reducer.dataApiMain,
	dataApiStadistics: state.api_reducer.dataApiStadistics,
	dataApiSyncGeneral: state.api_reducer.dataApiSyncGeneral,
	dataApiSyncStock: state.api_reducer.dataApiSyncStock,
	jobLogs: state.api_reducer.jobLogs,
	actionType: state.api_reducer.actionType
});

export default connect(
	mapStateToProps,
	{
		getMainApiStatus,
		getStadisticApiStatus,
		getSyncGeneralApiStatus,
		getSyncStockApiStatus,
		getJobLogs
	}
)(Monitor);
